export default __webpack_public_path__ + "static/media/myntra-clone.bab98f86.png";